export const ADVANCE_HIDE_SECTION_TYPE = 'ADVANCE_HIDE_SECTION';

export const startLocationTypesList = [
  { label: 'HOME', value: 'HOME' },
  { label: 'SLEEPER', value: 'SLEEPER' },
  { label: 'TERMINAL', value: 'TERMINAL' },
  { label: 'SUBTERMINAL', value: '/hierarchy/subTerminal' }
];
